import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarouselTemplate from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const copy = {
  logos: [
    carouselLogos.CHIME,
    carouselLogos.INSTACART,
    carouselLogos.DELIVEROO,
    carouselLogos.ATLASSIAN,
    carouselLogos.INTUIT,
    carouselLogos.SANOFI,
    carouselLogos.BOX,
    carouselLogos.CRAFTJACK,
    carouselLogos.VACASA,
  ],
  heading: `Developers love Segment`,
}

const LogoCarousel = () => (
  <StyledSection variant="noCopy">
    <Section.Contents>
      <LogoCarouselTemplate {...copy} />
    </Section.Contents>
  </StyledSection>
)

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      padding: 64px 40px;
    }

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding: 64px 80px;
    }
  }
`

export default LogoCarousel
